'use client';

import { __spreadArray } from '../../../_virtual/_tslib.js';
import { useState, useRef, useEffect } from 'react';
import { getPageName, convertKeysToSnakeCase } from '../../utils.js';

var INTERVAL_TIME = 500;
// This useHog function is used to centralize PostHog.
// In the future, any further requirements or changes can
// easily be updated here.
/**
 * A Hog Hook that return a tracking function and a tracking queue function.
 *
 * @returns  tracking, trackingQueue
 */
var useHog = function () {
    // Queue
    var _a = useState(false), isEnableQueue = _a[0], setIsEnableQueue = _a[1];
    var _b = useState([]), trackingQueues = _b[0], setTrackingQueues = _b[1];
    var intervalIdRef = useRef(null);
    var tracking = function (params, options) {
        try {
            if (!window.posthog) {
                console.error('PostHog is not ready!');
                return;
            }
            var _a = params.eventName, eventName = _a === void 0 ? '' : _a, _b = params.properties, properties = _b === void 0 ? {} : _b;
            // Do not tracking when there is no eventName provided
            if (eventName === '') {
                console.error('eventName is empty!');
                return;
            }
            // Parse page-name from window.location.pathname
            properties.pageName = getPageName();
            var parsedProperties = convertKeysToSnakeCase(properties);
            window.posthog.capture(eventName, parsedProperties, options);
        }
        catch (ex) {
            console.error('PostHog Error', ex);
        }
    };
    var trackingQueue = function (params, options) {
        try {
            // Run tracking when postHog is ready! No need to queue
            if (window.posthog) {
                tracking(params, options);
                return;
            }
            // PostHog is not ready then we should add it to queue
            var newTrackingQueues = __spreadArray([], trackingQueues, true);
            newTrackingQueues.push({
                id: "".concat(params.eventName, "_").concat(trackingQueues.length + 1),
                trackingParams: params,
                options: options
            });
            setTrackingQueues(newTrackingQueues);
            setIsEnableQueue(true);
        }
        catch (ex) {
            console.error('Tracking Queue Error', ex);
        }
    };
    var checkingPostHog = function () {
        if (!window.posthog) {
            return;
        }
        // Disable interval to prevent javascript running endless
        if (trackingQueues.length === 0) {
            setIsEnableQueue(false);
            return;
        }
        // Loop through queues
        trackingQueues.forEach(function (trackingItem) {
            // Send tracking event
            tracking(trackingItem.trackingParams, trackingItem === null || trackingItem === void 0 ? void 0 : trackingItem.options);
        });
        // All tracking is sent then we should empty it
        setTrackingQueues([]);
        setIsEnableQueue(false);
    };
    useEffect(function () {
        if (!isEnableQueue) {
            return;
        }
        if (trackingQueues.length === 0) {
            return;
        }
        intervalIdRef.current = setInterval(checkingPostHog, INTERVAL_TIME);
        return function () {
            intervalIdRef.current && clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
        };
    }, [isEnableQueue, trackingQueues]);
    return {
        tracking: tracking,
        trackingQueue: trackingQueue
    };
};

export { useHog as default };
//# sourceMappingURL=index.js.map
